import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}
const RefundIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "RefundGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.42589 8.68935C5.74979 5.45416 8.95586 3.17371 12.699 3.17371C17.6261 3.17371 21.6203 7.12472 21.6203 11.9985C21.6203 16.8723 17.6261 20.8234 12.699 20.8234C8.95586 20.8234 5.74979 18.5429 4.42589 15.3077C4.27999 14.9512 4.15698 14.5831 4.05865 14.2052C3.97677 13.8905 3.65252 13.7011 3.33442 13.7821C3.01631 13.8631 2.82481 14.1838 2.90668 14.4985C3.01823 14.9272 3.15778 15.3448 3.32329 15.7492C4.82276 19.4135 8.45478 22 12.699 22C18.283 22 22.8098 17.5222 22.8098 11.9985C22.8098 6.47488 18.283 1.99707 12.699 1.99707C8.45478 1.99707 4.82276 4.58362 3.32329 8.24786C3.12357 8.73591 2.96164 9.24312 2.84111 9.76589C2.62827 10.689 3.54185 11.3473 4.3475 11.076L6.94304 10.2022C7.254 10.0975 7.42028 9.76328 7.31445 9.45569C7.20861 9.1481 6.87073 8.98361 6.55977 9.0883L4.02075 9.94312C4.12468 9.51206 4.2606 9.09328 4.42589 8.68935ZM13.2938 7.29273C13.2938 6.96791 13.0276 6.70459 12.6991 6.70459C12.3707 6.70459 12.1045 6.96791 12.1045 7.29273V7.88086H10.9143C9.60059 7.88086 8.53564 8.93429 8.53564 10.2338C8.53564 11.5332 9.60059 12.5866 10.9143 12.5866H14.4822C15.1391 12.5866 15.6715 13.1134 15.6715 13.7631C15.6715 14.4128 15.1391 14.9395 14.4822 14.9395H9.1303C8.80188 14.9395 8.53564 15.2029 8.53564 15.5278C8.53564 15.8526 8.80188 16.116 9.1303 16.116H12.1045V16.7053C12.1045 17.0302 12.3707 17.2935 12.6991 17.2935C13.0276 17.2935 13.2938 17.0302 13.2938 16.7053V16.116H14.4822C15.7959 16.116 16.8608 15.0626 16.8608 13.7631C16.8608 12.4636 15.7959 11.4102 14.4822 11.4102H10.9143C10.2574 11.4102 9.72496 10.8835 9.72496 10.2338C9.72496 9.58402 10.2574 9.05731 10.9143 9.05731H16.2662C16.5946 9.05731 16.8608 8.79395 16.8608 8.46908C16.8608 8.14422 16.5946 7.88086 16.2662 7.88086H13.2938V7.29273Z"
        fill="#696969"
      />
    </svg>
  );
};

export default RefundIcon;
